<script setup lang="ts">
import CallToActionComponent from "~/templates/components/cms/CallToActionComponent.vue";
import LinkComponent from "~/templates/components/cms/LinkComponent.vue";
import {
  filterNodesByType,
  getId,
  getImageAlt,
  getImageHeight,
  getImageWidth,
  imageName,
  imagePath,
  mapNodes,
} from "~/utils/helper/magnolia";

export interface FooterImprintProps {
  imprint: object;
}

defineProps<FooterImprintProps>();

const { currentLanguage } = useMagnoliaLanguage();
</script>

<template>
  <div class="flex flex-col gap-8">
    <div class="flex flex-wrap items-center">
      <img
        v-if="imprint.image"
        :src="imagePath(imprint.image)"
        :alt="imageName(imprint.image)"
        :height="getImageHeight(imprint.image) ?? 96"
        :width="getImageWidth(imprint.image) ?? 20"
        class="w-24 lg:w-32"
      />
      <img
        v-else
        src="~/assets/img/logo/logo-primary.svg"
        width="96"
        height="20"
        class="w-24 lg:w-32"
        alt=""
      />
      <div class="-mr-2 ml-auto flex">
        <LinkComponent
          v-for="social in filterNodesByType(
            mapNodes(imprint.socialIcons ?? {}),
            'mgnl:contentNode',
          )"
          :key="getId(social)"
          class="relative h-11 w-11 rounded-md p-2"
          :link="social.link"
        >
          <img
            class="absolute left-[calc(50%-12px)] top-[calc(50%-12px)] h-6 w-6"
            :src="imagePath(social.image)"
            :alt="getImageAlt(social.image)"
          />
        </LinkComponent>
      </div>
    </div>
    <div class="responsive-gap flex flex-row flex-wrap">
      <div
        class="mb-4 flex w-full flex-col flex-wrap items-start gap-4 xl:order-2 xl:mb-0 xl:w-auto xl:flex-row"
      >
        <CallToActionComponent
          v-for="link in filterNodesByType(mapNodes(imprint), 'nav:link')"
          :key="getId(link)"
          class="hover:text-dark-blue"
          :link="link.link"
        />
      </div>
      <div v-if="imprint.copyright" class="font-medium xl:order-1">{{ imprint.copyright }}</div>
      <div v-if="imprint.languageSelector" class="ml-auto xl:order-3">{{ currentLanguage }}</div>
    </div>
    <div v-if="imprint.disclosureText" class="prose text-xs" v-html="imprint.disclosureText"></div>
  </div>
</template>
